/* NodeIcon — Renders a FontAwesome class name (e.g. "fa-tasks") or emoji fallback */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library, type IconName } from '@fortawesome/fontawesome-svg-core';
import {
  faPlusCircle,
  faCheckCircle,
  faArrowRight,
  faEnvelope,
  faBell,
  faClock,
  faExchangeAlt,
  faTasks,
  faCodeBranch,
} from '@fortawesome/free-solid-svg-icons';

// Register only the icons used by automation node definitions
library.add(
  faPlusCircle,
  faCheckCircle,
  faArrowRight,
  faEnvelope,
  faBell,
  faClock,
  faExchangeAlt,
  faTasks,
  faCodeBranch,
);

export default function NodeIcon({ icon }: { icon: string }) {
  if (!icon) return null;

  // If it doesn't start with "fa-", treat as emoji / raw text
  if (!icon.startsWith('fa-')) {
    return <span>{icon}</span>;
  }

  // "fa-exchange-alt" → "exchange-alt"
  const iconName = icon.replace(/^fa-/, '') as IconName;

  try {
    return <FontAwesomeIcon icon={['fas', iconName]} />;
  } catch {
    return <i className={`fas ${icon}`} />;
  }
}
